import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import DocumentTitle from 'react-document-title'
import MatchPlayer from '../../components/MatchPlayer'
import Telemetry from '../../models/Telemetry.js'
import parsePCOBTelemetry from '../../models/PCOBTelemetry.parser.js'
import { fetchMatchReplay } from '../../lib/supabaseApi.js'
import { toInternalMapName } from '../../lib/util.js'

const Message = styled.p`
    text-align: center;
    margin: 2rem 0;
`

class SupabaseMatch extends React.Component {
    state = {
        loading: true,
        error: null,
        match: null,
        telemetry: null,
        rosters: null,
        globalState: null,
        playerName: '',
        playerNames: {},
    }

    componentDidMount() {
        this.loadReplay()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.matchId !== this.props.match.params.matchId) {
            this.setState({
                loading: true,
                error: null,
                match: null,
                telemetry: null,
                rosters: null,
                globalState: null,
                playerName: '',
                playerNames: {},
            }, this.loadReplay)
        }
    }

    loadReplay = async () => {
        const matchId = this.props.match.params.matchId
        if (!matchId) {
            this.setState({ loading: false, error: 'Maç bulunamadı.' })
            return
        }

        const result = await fetchMatchReplay(matchId)
        if (!result || !result.replay) {
            this.setState({ loading: false, error: 'Maç verisi yüklenemedi.' })
            return
        }

        const replay = result.replay
        const storedMapName = result.map_name || null

        if (replay.format !== 'pob' || replay.version !== 2) {
            this.setState({ loading: false, error: 'Bu maç formatı desteklenmiyor (POB v2 gerekli).' })
            return
        }

        try {
            const parsed = parsePCOBTelemetry(replay)
            const match = storedMapName
                ? { ...parsed.match, mapName: toInternalMapName(storedMapName) }
                : parsed.match
            const { state, globalState, focusedPlayerName } = parsed
            const telemetry = Telemetry(state)
            const rosters = telemetry.finalRoster(focusedPlayerName)
            const playerNames = rosters.reduce((acc, roster) => {
                roster.forEach(name => { acc[name] = true })
                return acc
            }, {})

            this.setState({
                loading: false,
                match,
                telemetry,
                rosters,
                globalState,
                playerName: focusedPlayerName,
                playerNames,
                error: null,
            })
        } catch (err) {
            console.error('Replay parse error:', err)
            this.setState({ loading: false, error: 'Maç işlenirken hata oluştu.' })
        }
    }

    render() {
        const {
            loading,
            error,
            match,
            telemetry,
            rosters,
            globalState,
            playerName,
            playerNames,
        } = this.state

        let content

        if (loading) {
            content = <Message>Maç yükleniyor...</Message>
        } else if (error) {
            content = (
                <Message>
                    {error}
                    <br />
                    <a href="/">Ana sayfaya dön</a>
                </Message>
            )
        } else if (match && telemetry) {
            content = (
                <MatchPlayer
                    match={match}
                    rawTelemetry={null}
                    telemetry={telemetry}
                    rosters={rosters}
                    globalState={globalState}
                    playerName={playerName}
                    playerNames={playerNames}
                />
            )
        } else {
            content = <Message>Veri yok.</Message>
        }

        return (
            <React.Fragment>
                <DocumentTitle title="Maç izle | DropScore" />
                {content}
            </React.Fragment>
        )
    }
}

export default withRouter(SupabaseMatch)



// WEBPACK FOOTER //
// ./src/routes/SupabaseMatch/index.js